const activeDataAttr = 'data-nav-show-drop-down';

export const initNavDropDownHoverEffect = () => {
  const navItems = document.querySelectorAll(
    '[data-site-header-nav-item], [data-pro-pages-navigation-item]'
  );

  navItems.forEach((navItem) => {
    const dropDownNavEl = navItem.querySelector('[data-navigation-dd]');

    navItem.addEventListener('mouseleave', () => {
      hideDropdown(dropDownNavEl);
    });

    navItem.addEventListener('focusin', () => {
      showDropdown(dropDownNavEl);
    });

    navItem.addEventListener('focusout', (event) => {
      if (!navItem.contains(event.relatedTarget)) {
        hideDropdown(dropDownNavEl);
      }
    });
  });
};

function showDropdown(dropdownEl) {
  dropdownEl.setAttribute(activeDataAttr, 'true');
}

function hideDropdown(dropdownEl) {
  dropdownEl.setAttribute(activeDataAttr, 'false');
}
